module.exports = __webpack_public_path__ + "img/human_train_footman_small.5c3e35e6.png";